import { FIQAssist } from "../app";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { ServiceCaseService } from "./fiqassistApi/serviceCaseService";
import * as Rx from "rxjs"
import { LogService } from "./logService";
import { SearchData, CompactServiceCase } from "../models/serviceCase";
import { CollectionResult } from "../interfaces/iFqs";

@Injectable({
    module: FIQAssist,
    selector: ServiceCaseProjectService.selector
})
export class ServiceCaseProjectService {
    public static selector = "serviceCaseProjectService";

    constructor(
        @Inject() private serviceCaseService: ServiceCaseService,
        @Inject() private logService: LogService,
    ) {

    }
    private _currentSearchSubscription: Rx.Subscription;
    private get currentSearch(): Rx.Subscription {
        return this._currentSearchSubscription;
    }
    private set currentSearch(subscription: Rx.Subscription) {
        if (this._currentSearchSubscription) {
            this._currentSearchSubscription.unsubscribe();
        }
        this._currentSearchSubscription = subscription;
    }

    private _currentSubject: Rx.Subject<CollectionResult<CompactServiceCase>>;
    private get currentSubject(): Rx.Subject<CollectionResult<CompactServiceCase>> {
        return this._currentSubject;
    }

    private set currentSubject(subject: Rx.Subject<CollectionResult<CompactServiceCase>>) {
        if (this._currentSubject) {
            this._currentSubject.complete();
        }
        this._currentSubject = subject;
    }

    private _currentResult: CollectionResult<CompactServiceCase>;
    public get CurrentResult(): CollectionResult<CompactServiceCase> {
        return this._currentResult;
    }

    public get CaseNumber() {
        return this.searching;
    }
    private searching = false;

    public Search(caseNumber: string, customers: any[], limit: number = 100, skip: number = 0, fullTree = false) {
        this._currentResult = null;
        var subject = new Rx.Subject<CollectionResult<CompactServiceCase>>();
        this.searching = true;
        var subscription = Rx.Observable.fromPromise(
            this.serviceCaseService.AdvancedSearch((fullTree ? { includeProjectTree: true, caseNumber: caseNumber } : { includeNeighbour: true, caseNumber: caseNumber }) as SearchData, customers, limit, skip)
        ).subscribe({
            next: result => {
                this._currentResult = result;
                subject.next(this._currentResult);
            },
            error: error => {
                this.logService.error('ServiceCaseProjectService', 'Error while searching', error);
                subject.error(error);
            },
            complete: () => {
                this.searching = false;
                subject.complete();
            }
        });
        this.currentSearch = subscription;
        this.currentSubject = subject;
        return subject.asObservable();
    }
}
